import DashboardHeader from "@/components/DashboardHeader";
import Dropzone from "@/components/dropzone/DropZone";
import {
  AstericSign,
  FormHookInput,
  Input,
  Loader,
  Button,
  emailValidator,
  namePattern,
  NON_DIGIT_REGEX,
  STARTS_WITH_OPTIONAL_1_REGEX,
  convertDollarToCents,
  convertCentsToDollars,
  avoidEmptyStringValidator,
  slugNameValidator,
  numberWithoutDecimal,
  dollarAmountValidation,
  phoneNumberPattern,
  FormHookTextArea,
} from "@thdinc/hpf-shared";

import React, { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm, useWatch } from "react-hook-form";
import useLoading from "@/hooks/useLoading";
import useError from "@/hooks/useError ";

import { DeleteIcon } from "@/constants/utils/svgs";

import "react-select-search/style.css";
import { TIME_ZONES_LIST } from "@/constants/CompanyData";
import { API_ROUTES } from "@/services/environment";
import ChangesAlert from "@/components/alert/ChangesAlert";
import { GET, PATCH, POST, POST_MULTIPART, DELETE } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import ImageUploadFunDropZone from "@/constants/utils/ImageUploadDropZoneFun";
import Alert from "@/components/alert/Alert";
import PlacesInput from "@/components/input/PlacesInput";

import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import { FaPlay } from "react-icons/fa";
import FormModal from "@/components/modals/FormModal";
import { s3DeleteFile, s3UploadFile } from "@/helpers/FileFunctions";

import { CompanyInterface } from "../company/interface";
import InputVideo from "@/components/input/InputVideo";
// add company interface

export interface PlacesData {
  address: string;
  lat: number;
  lng: number;
  city: string;
  state: string;
  zip: string;
}
// company form interfaces
type CompanyForm = {
  companyName: string;
  address: string;
  address2: string;
  city: string;
  stripeId: string;
  state: string;
  postalCode: string;
  distance: string;
  timezone: string;
  location: string;
  email: string;
  radius: number;
  description: string;
  minRadius: string;
  mileageFee: string;
  slugName: string;
  stripeEmail: string;
  google_review_link: string;
  video?: File | null;
  facebook?: string;
  instagram?: string;
  phone_number?: string;
  place_id?: string;
  data_id?: string;
};
interface FileInterface {
  file: File | null;
  url: string;
}

const MyBusiness = () => {
  const dispatch = useDispatch();

  const { getCompanyApi, editCompanyApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { business_id } = useAppSelector((store) => store.user);

  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    control,
    watch,
    formState: { errors },
    trigger,
  } = useForm<CompanyForm>({ defaultValues: { radius: 30 } });
  const [companyData, setCompanyData] = useState<CompanyInterface | null>(null);
  const [primaryImage, setPrimaryImage] = useState<FileInterface | null>(null);
  const [logoImage, setLogoImage] = useState<FileInterface | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [deleteImageUrls, setDeleteImageUrls] = useState<string[]>([]);
  const [imgLoad, setImgLoad] = useState({
    logo: false,
    primary: false,
    others: false,
  });
  const [portfolioImages, setPortfolioImage] = useState<FileInterface[]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [error, setCustomError] = useError();
  const [selectTimeZone, setSelectTimeZone] = useState<string>("null");
  const [modal, setModal] = useState<boolean>(false);
  const [payloadState, setPayloadState] = useState<any | null>(null);
  const [place, setPlace] = useState<PlacesData | null>(null);
  const [deleteVideos, setDeleteVideos] = useState<string[]>([]);
  // Get the initial values when the component mounts
  const initialValues: CompanyForm = getValues();

  // State to track the previous values
  const [previousValues, setPreviousValues] =
    useState<CompanyForm>(initialValues);

  // Ref to track if it's the first render
  const isInitialRender = useRef(true);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      // Skip the effect on the first render
      if (isInitialRender.current) {
        isInitialRender.current = false;
        return;
      }

      dispatch(formStateChange(false));

      // Compare new values with the previous values
      const hasChanged = (Object.keys(value) as Array<keyof CompanyForm>).some(
        (key) => value[key] !== previousValues[key]
      );

      if (hasChanged) {
        //  dispatch(formStateChange(true));

        // Set previous values to the current values
        setPreviousValues(value as CompanyForm);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch, previousValues, dispatch]);
  const removeImage = async (
    type: string,
    index?: number,
    imageURL?: string
  ) => {
    try {
      dispatch(formStateChange(true));

      if (type == "logo") {
        const res = await s3DeleteFile(
          logoImage?.url,
          refreshToken as string,
          business_id
            ? {
                businessId: business_id,
                imageType: "logo",
                remainingUrls: null,
              }
            : null
        );
        setLogoImage(null);
        // setLogo(null);
      }
      if (type === "profile") {
        const res = await s3DeleteFile(
          primaryImage?.url,
          refreshToken as string,
          business_id
            ? {
                businessId: business_id,
                imageType: "primary",
                remainingUrls: null,
              }
            : null
        );
        setPrimaryImage(null);
        // setCompanyImg(null);
      }
      // in case of portfolio images
      else {
        setPortfolioImage(portfolioImages.filter((p, i) => i !== index));
        if (imageURL) setDeleteImageUrls([...deleteImageUrls, imageURL]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const onSubmit: SubmitHandler<CompanyForm> = async (data) => {
    // if (!place) {
    //   setCustomError("address", "Please select location");
    //   return;
    // }
    console.log("logoImage", logoImage);
    setCustomError("address", "");
    try {
      if (primaryImage && selectTimeZone !== "null" && logoImage) {
        const formData = new FormData();
        formData.append("name", data.companyName);
        formData.append("email", data.email);
        videos.map((vid) => {
          formData.append("videos", vid.url);
        });
        // if places is selected from google places input
        if (place) {
          formData.append("address1", place?.address);
          formData.append("city", place.city);
          formData.append("state", place.state);
          formData.append("lat", place.lat.toString());
          formData.append("long", place.lng.toString());
        }
        primaryImage && formData.append("profile_image", primaryImage?.url);
        logoImage && formData.append("logo", logoImage.url);
        formData.append("address2", data.address2);
        formData.append(
          "milage_fee",
          data?.mileageFee ? convertDollarToCents(data?.mileageFee) : "0"
        );
        formData.append("postal_code", data.postalCode);
        formData.append("slug_name", data.slugName);
        formData.append("stripe_id", data.stripeId);
        formData.append("radius", String(data.radius));
        formData.append("description", data.description);
        formData.append("timezone", selectTimeZone);

        formData.append("stripe_email", data.stripeEmail);
        formData.append("google_review_link", data.google_review_link);
        data?.facebook && formData.append("facebook", data?.facebook);
        data?.instagram && formData.append("instagram", data?.instagram);
        data?.phone_number &&
          formData.append("phone_number", data?.phone_number);
        data?.data_id && formData.append("data_id", data?.data_id);
        portfolioImages.map((p) => {
          formData.append("portfolioImages", p.url);
        });
        setPayloadState(formData);
        setModal(true);
        if (business_id) {
          deleteImageUrls.map((url) => {
            s3DeleteFile(url, refreshToken as string, {
              businessId: business_id,
              imageType: "portfolio",
              remainingUrls: portfolioImages
                .filter((p) => p.url !== url)
                .map((i) => i.url),
            });
          });
          deleteVideos.map((url) => {
            s3DeleteFile(url, refreshToken as string, {
              businessId: business_id,
              imageType: "videos",
              remainingUrls: videos
                .filter((p) => p.url !== url)
                .map((i) => i.url),
            });
          });
        }
      } else if (!primaryImage) {
        setCustomError("dp", "Please upload primary picture");
      } else if (!logoImage) {
        setCustomError("logo", "Please upload logo image");
      } else if (selectTimeZone === "null") {
        setCustomError("timezone", "Please select timezone");
      }
    } catch (error) {
      console.log(error);
    } finally {
      stopLoading();
    }
  };

  // timezone from google places input
  const selectTimeZoneFun = (zone: string) => {
    dispatch(formStateChange(true));

    setSelectTimeZone(zone);
    if (error?.name === "timezone") {
      setCustomError("", "");
    }
  };

  const watchedRadius = useWatch({ control: control, name: "radius" });

  useEffect(() => {
    const getData = async () => {
      // in order to get the company data in view type page
      startLoading();
      try {
        const result = await GET(
          `${getCompanyApi}/${business_id}`,
          refreshToken
        );
        //update state for modal
        setCompanyData(result?.data);
        setValue("companyName", result?.data?.name);
        setValue("email", result?.data?.email);
        setValue("address2", result?.data?.address2);
        setValue("radius", result?.data?.radius);
        setValue("postalCode", result?.data?.postal_code);
        setValue("description", result?.data?.description);
        setValue("stripeId", result?.data?.stripe_id);
        setValue("slugName", result?.data?.slug);
        setValue("stripeEmail", result?.data?.stripe_email);
        setValue("google_review_link", result?.data?.google_review_link);
        setValue("facebook", result?.data?.facebook);
        setValue("instagram", result?.data?.instagram);
        setValue("phone_number", result?.data?.phone_number);
        setValue("data_id", result?.data?.data_id);
        //convert fee data using reusable function
        setValue(
          "mileageFee",
          convertCentsToDollars(result?.data?.mileage_fee)
        );

        setLogoImage({ file: null, url: result?.data?.logo });
        setPrimaryImage({ file: null, url: result?.data?.open_graph_image });
        setPortfolioImage(
          result?.data?.images.map((image: string) => {
            return { file: null, url: image };
          })
        );
        setVideos(
          result.data.videos.map((vid: string) => {
            return {
              file: null,
              url: vid,
            };
          })
        );
      } catch (err) {
        console.log(String(err));
      } finally {
        stopLoading();
      }
    };
    getData();
  }, []);

  const updateCompany = async () => {
    // Create a new company
    dispatch(formStateChange(false));

    try {
      startLoading();
      setModal(false);
      const res = await PATCH(
        `${editCompanyApi}/${business_id} `,
        payloadState,
        refreshToken
      );
      if (res.data.success) {
        // update business id for next steps
        // addBusinessId(res?.data?.business_id);
        stopLoading();
        Alert({ type: "success", message: "Company updated successfully" });
        // condition for next steps
      } else {
        stopLoading();
        Alert({ type: "error", message: res.data.message });
      }
    } catch (error) {
      console.log("error", error);
      stopLoading();
    }
  };
  const uploadCompanyImg = async (file: any) => {
    setImgLoad({ ...imgLoad, primary: true });

    dispatch(formStateChange(true));
    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        const res = await s3UploadFile(f, refreshToken as string);
        if (res.data.success) {
          setPrimaryImage({ file: f, url: res.data.url });
        }
        setCustomError("dp", "");
      }
    } catch (error: any) {
      console.log("error", error.message);
      setCustomError("dp", error.message);
    } finally {
      setImgLoad({ ...imgLoad, primary: false });
    }
  };
  const uploadCompanyLogo = async (file: any) => {
    // removeImage("logo");
    setImgLoad({ ...imgLoad, logo: true });
    dispatch(formStateChange(true));

    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        const res = await s3UploadFile(f, refreshToken as string);
        if (res.data.success) {
          setLogoImage({ file: f, url: res.data.url });
        }
      }
    } catch (error: any) {
      console.log("error", error.message);
      setCustomError("logo", error.message);
    } finally {
      setImgLoad({ ...imgLoad, logo: false });
    }
  };
  const otherImagesUpload = async (file: any, type: string) => {
    dispatch(formStateChange(true));
    setImgLoad({ ...imgLoad, others: true });
    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        const res = await s3UploadFile(f, refreshToken as string);
        // const res = await POST_MULTIPART(
        //   bsnsUploadImg,
        //   { image: f },
        //   refreshToken
        // );
        if (res.data.success) {
          Alert({ type: "success", message: res.data.message });
          setPortfolioImage([
            ...portfolioImages,
            { file: f, url: res.data.url },
          ]);
        }
        setCustomError("other", "");
      }
    } catch (error: any) {
      console.log("error", error.message);
      setCustomError("other", error.message);
    } finally {
      setImgLoad({ ...imgLoad, others: false });
    }
  };

  const onAddressSelected = (
    address: string,
    lat: number,
    lng: number,
    city: string,
    state: string,
    zip: string,
    timezone: string
  ) => {
    // on address selected google places will provide the details
    if (timezone) {
      // if timezone is available
      setSelectTimeZone(timezone);
    }
    setValue("postalCode", zip ? zip : "");
    setPlace({
      address: address,
      lat: lat,
      lng: lng,
      city: city,
      state: state,
      zip: zip,
    });
    dispatch(formStateChange(true));
  };
  useEffect(() => {
    setSelectTimeZone(companyData?.timezone as string);
    setPlace({
      address: companyData?.address1 || "",
      city: companyData?.city || "",
      lat: companyData?.location?.coordinates[1] as number,
      lng: companyData?.location?.coordinates[0] as number,
      state: companyData?.state as string,
      zip: companyData?.postal_code as string,
    });
  }, [companyData]);

  // === videos related ===
  const [curVid, setcurVid] = useState<string>("");
  const [videos, setVideos] = useState<FileInterface[]>([]);

  const handleVideoChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCustomError("", "");
    startLoading();
    const file = event.target.files?.[0];
    if (file) {
      const maxFileSizeMB = 20;
      const fileSizeMB = file.size / (1024 * 1024);

      if (fileSizeMB > maxFileSizeMB) {
        setCustomError(
          "video",
          `The file ${file.name} is too large. Maximum size allowed is ${maxFileSizeMB} MB.`
        );
        // setSelectedVideo(null);
        return;
      }
      const res = await s3UploadFile(file, refreshToken as string);
      // const res = await POST_MULTIPART(
      //   bsnsUploadVid,
      //   { video: file },
      //   refreshToken
      // );
      if (res.data.success) {
        Alert({ type: "success", message: res.data.message });
        // setSelectedVideo(file);
        setVideos([...videos, { file, url: res.data.url }]);
        stopLoading();
      }
    }
  };
  const handleRemoveVideo = async (url: string, index: number) => {
    setDeleteVideos([...deleteVideos, url]);
    setVideos(videos.filter((v, i) => i !== index));
  };
  return (
    <div>
      <DashboardHeader title={"Edit Business"}></DashboardHeader>
      <div className="bg-white rounded-2xl  p-6  mx-auto shadow-sm">
        {/* images upload */}

        <div className="flex gap-4 flex-row flex-wrap sm:flex-nowrap items-start">
          <div className="w-full ">
            <div className="flex justify-center sm:justify-start gap-2">
              <div>
                <div className=" font-semibold my-2">Business Logo</div>
                <Dropzone
                  imgLoad={imgLoad.logo}
                  image={logoImage?.url}
                  onDrop={uploadCompanyLogo}
                  isReplace={true}
                ></Dropzone>
              </div>
              <div className="">
                <div className=" font-semibold my-2">Primary Picture</div>
                <Dropzone
                  imgLoad={imgLoad.primary}
                  image={primaryImage?.url}
                  onDrop={uploadCompanyImg}
                  isReplace={true}
                ></Dropzone>
                {error?.name === "dp" && (
                  <p className="text-primary-red ">{error.message}</p>
                )}
              </div>
            </div>
            <div>
              {error?.name === "logo" && (
                <p className="text-primary-red ">{error.message}</p>
              )}
            </div>
          </div>
          <div className="w-full flex gap-2 items-end justify-center sm:justify-start">
            <div>
              <div className=" font-semibold my-2">Portfolio Pictures</div>
              <div className="flex items-start  gap-3 flex-wrap">
                {portfolioImages.map((p, index) => {
                  return (
                    <Dropzone
                      key={index}
                      imgLoad={imgLoad.others}
                      image={p.url}
                      removeImage={() => removeImage("other1", index, p.url)}
                      onDrop={(e: File) => otherImagesUpload(e, "other1")}
                    ></Dropzone>
                  );
                })}
                <Dropzone
                  imgLoad={imgLoad.others}
                  onDrop={(e: File) => otherImagesUpload(e, "other1")}
                ></Dropzone>
              </div>

              {error?.name === "other" && (
                <p className="text-primary-red ">{error.message}</p>
              )}
            </div>
          </div>
        </div>
        <div className="">
          <div className=" font-semibold my-2"> Videos</div>
          <div className="flex items-start gap-3 flex-wrap">
            {videos.length > 0 &&
              videos.map((vid, i) => {
                return (
                  <div key={i}>
                    <div
                      onClick={() => {
                        setcurVid(vid.url);
                        setShowForm(true);
                      }}
                      className="relative overflow-hidden inline-block"
                    >
                      <FaPlay className="absolute text-primary-red  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 " />
                      <video
                        className="rounded-xl w-full  cursor-pointer  max-h-[150px]  "
                        src={vid.url}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    <div
                      className="flex justify-center mt-1 cursor-pointer "
                      onClick={() => handleRemoveVideo(vid.url, i)}
                    >
                      <div className="bg-p-gray p-1 rounded-full">
                        <DeleteIcon />
                      </div>
                    </div>
                  </div>
                );
              })}
            <InputVideo
              width="w-56"
              height="h-[150px]"
              accept="video/*"
              onChange={handleVideoChange}
              inputProps={{ multiple: false }}
              isLoading={isLoading}
            />
          </div>

          {error?.name === "video" && (
            <p className="text-primary-red ">{error.message}</p>
          )}

          {/* Preview modal */}
          <FormModal
            modalTitle="Video Preview"
            width="w-full md:w-[550px]"
            isOpen={showForm}
            onClose={() => setShowForm(false)}
          >
            <video
              controls
              className="rounded-xl w-[100vw] cursor-pointer h-[70vh]"
              src={curVid}
            >
              Your browser does not support the video tag.
            </video>
          </FormModal>
        </div>
        <form className="flex flex-col gap-5" onSubmit={handleSubmit(onSubmit)}>
          <div className="flex gap-4 flex-col sm:flex-row">
            <div className="w-full ">
              <div className=" font-semibold my-2 text-gray-400">
                Business Name <AstericSign />
              </div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Business Name"
                register={register("companyName", {
                  required: "Business Name is required",
                  pattern: avoidEmptyStringValidator,
                  maxLength: {
                    value: 75,
                    message: "Business Name can't be more than 75 characters.",
                  },
                  onBlur: () => trigger("companyName"),
                  onChange: () => {
                    const regex = /[^a-zA-Z0-9\s]/g;
                    let slugName = getValues("companyName")
                      .trim()
                      .replace(regex, "");
                    slugName = slugName.replace(/\s+/g, " ");
                    setValue(
                      "slugName",
                      slugName.toLowerCase().replace(/\s/g, "-")
                    );
                  },
                  // pattern: {
                  //   value: /^[\w\s\.]+$/, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                  //   message: "Invalid first name format",
                  // },
                })}
                error={errors.companyName}
              />
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2 text-gray-400">
                Business Email <AstericSign />
              </div>
              <FormHookInput
                disabled
                type="email"
                placeholder="Business Email"
                register={register("email", {
                  required: "Business Email is required!",
                  pattern: emailValidator,
                  onBlur: () => trigger("email"),
                })}
                error={errors.email}
              />
            </div>
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full ">
              <div className=" font-semibold my-2 text-gray-400">
                Slug Name <AstericSign />
              </div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Slug Name"
                register={register("slugName", {
                  maxLength: {
                    value: 75,
                    message: "Slug Name can't be more than 75 characters.",
                  },
                  required: "Slug Name is required!",
                  pattern: slugNameValidator,
                  onBlur: () => trigger("slugName"),
                })}
                error={errors.slugName}
              />
            </div>
            <div className="w-full ">
              {" "}
              <div>
                <div className=" font-semibold my-2 text-gray-400">
                  Stripe Email <AstericSign />
                </div>
                <FormHookInput
                  disabled
                  type="email"
                  placeholder="Stripe Email"
                  register={register("stripeEmail", {
                    required: "Stipe email is required!",
                    pattern: emailValidator,
                    onBlur: () => trigger("stripeEmail"),
                  })}
                  error={errors.stripeEmail}
                />
              </div>
            </div>
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full ">
              <div className=" font-semibold my-2 text-gray-400">
                Main Address <AstericSign />
              </div>

              <PlacesInput
                disabled
                defaultValue={companyData?.address1}
                onAddressSelected={onAddressSelected}
                error={""}
              />
              {error?.name === "address" && (
                <p className="text-red-500 text-xs mt-1 py-">
                  {error?.message}
                </p>
              )}
            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2 text-gray-400">
                Address 2{" "}
              </div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Address 2"
                register={register("address2", {
                  pattern: avoidEmptyStringValidator,
                })}
                error={errors.address2}
              />
            </div>
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2 text-gray-400">
                Postal Code{" "}
              </div>
              <FormHookInput
                disabled
                type="text"
                placeholder="Postal Code"
                register={register("postalCode", {
                  pattern: {
                    value: /^[0-9]{5}(-[0-9]{4})?$/, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                    message: "Invalid Postal Code",
                  },
                  // required: "P is required",
                })}
                error={errors.postalCode}
              />
            </div>
            <div className="w-full ">
              {" "}
              <div>
                <div className=" font-semibold my-2">Google Review Link </div>
                <FormHookInput
                  type="text"
                  placeholder="Google Review Link"
                  register={register("google_review_link", {
                    // onBlur: () => trigger("google_review_link"),
                  })}
                  error={errors.google_review_link}
                />
              </div>
            </div>
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2 text-gray-400">
                {" "}
                Time Zone <AstericSign />
              </div>

              <SelectSearchInput
                disabled
                placeholder="Select Time Zone"
                options={TIME_ZONES_LIST}
                value={selectTimeZone}
                onChange={selectTimeZoneFun}
              />
              {error?.name === "timezone" && (
                <p className="text-red-500 text-xs mt-1 py-">
                  {error?.message}
                </p>
              )}
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2 text-gray-400">
                Stripe ID <AstericSign />
              </div>
              <FormHookInput
                disabled
                updatedStyle="w-full px-4 py-3 bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-500"
                type={"text"}
                placeholder="acct_1032D82eZvKYlo2C"
                register={register("stripeId", {
                  required: "Stripe ID is required",
                  // pattern: {
                  //   value: /^acct_[a-zA-Z0-9]{16}$/, // allow letters, hyphens, and apostrophes, between 1 and 50 characters
                  //   message: "Invalid Stripe ID",
                  // },
                })}
                error={errors.stripeId}
              />
            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2 text-gray-400">Data Id</div>
              <FormHookInput
                disabled
                updatedStyle="w-full px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-500"
                type="text"
                placeholder="Data Id"
                register={register("data_id", {
                  onChange: (e) => {
                    const { value } = e.target;
                    e.target.value = value;
                  },
                })}
                error={errors.data_id}
              />
            </div>
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2 text-gray-400">
                Min Distance (Miles) <AstericSign />
              </div>
              <FormHookInput
                type="text"
                value="30"
                disabled={true}
                placeholder="30-200 Miles"
                register={register("minRadius", {})}
                error={errors.minRadius}
              />
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2 text-gray-400">
                Max Distance (miles) <AstericSign />
              </div>
              <FormHookInput
                disabled
                type="number"
                placeholder="30-200 Miles"
                register={register("radius", {
                  required: "Max Distance is required",
                  pattern: numberWithoutDecimal,
                  max: {
                    value: 200,
                    message: "Max Distance can't be more than 200 miles.",
                  },
                  min: {
                    value: 30,
                    message: "Max Distance can't be less than 30 miles",
                  },
                  onBlur: () => trigger("radius"),
                })}
                error={errors.radius}
              />
            </div>

            {watchedRadius > 30 && (
              <div className="w-full">
                <div className=" font-semibold my-2 text-gray-400">
                  Cost per mile ($) <AstericSign />
                </div>
                <FormHookInput
                  disabled
                  type="text"
                  placeholder="Cost per mile"
                  register={register("mileageFee", {
                    required: "Mileage cost is required",
                    pattern: dollarAmountValidation,

                    max: {
                      value: 999,
                      message:
                        "Mileage cost must not exceed the allowable limit",
                    },
                    min: {
                      value: 0,
                      message: "Mileage cost can't be less than 0$",
                    },
                    onBlur: () => trigger("mileageFee"),
                  })}
                  error={errors.mileageFee}
                />
              </div>
            )}
          </div>
          <div className="flex gap-4  flex-col sm:flex-row">
            <div className="w-full">
              <div className=" font-semibold my-2">Facebook</div>
              <FormHookInput
                type="text"
                placeholder="Facebook Link"
                register={register("facebook")}
                error={errors.instagram}
              />
            </div>
            <div className="w-full">
              <div className=" font-semibold my-2">Instagram</div>
              <FormHookInput
                type="text"
                placeholder="Instagram Link"
                register={register("instagram", {})}
                error={errors.instagram}
              />
            </div>
            <div className="w-full ">
              <div className=" font-semibold my-2">
                Phone Number <AstericSign />
              </div>
              <FormHookInput
                type="text"
                placeholder="Phone Number"
                register={register("phone_number", {
                  required: "Phone number is required",
                  pattern: {
                    value: phoneNumberPattern,
                    message: "Please enter a valid U.S format.",
                  },
                  onChange: (e) => {
                    let { value } = e.target;
                    // Remove all non-digit characters except the initial "+1 "
                    value = value
                      .replace(NON_DIGIT_REGEX, "")
                      .replace(STARTS_WITH_OPTIONAL_1_REGEX, "1"); // Ensures it starts with "1"
                    value = `+1 ${value.substring(1, 4)} ${value.substring(
                      4,
                      7
                    )} ${value.substring(7, 11)}`.trim();
                    e.target.value = value;
                  },
                })}
                error={errors.phone_number}
              />
            </div>
          </div>

          <div className="w-full ">
            <div className=" font-semibold my-2 ">
              Business Description <AstericSign />
            </div>
            <div className="overflow-hidden">
              <FormHookTextArea
                type="text"
                rows={6}
                placeholder="Description "
                register={register("description", {
                  pattern: avoidEmptyStringValidator,
                  required: "Description is required",
                  maxLength: {
                    value: 2500,
                    message:
                      "Description length can't be more than 2500 characters.",
                  },
                  onBlur: () => trigger("description"),
                })}
                error={errors.description}
              />
            </div>
          </div>
          {
            <div className="text-end">
              <Button
                classes={
                  "bg-primary-red text-white hover:bg-primary-red-button-hover "
                }
                type="submit"
                disabled={isLoading}
              >
                {" "}
                {isLoading ? <Loader  color="bg-gray-50" /> : "Save"}
              </Button>
            </div>
          }
        </form>
      </div>
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want to save this changes?`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setModal(false);
        }}
        handleSaveChanges={updateCompany}
        isOpen={modal}
      />
    </div>
  );
};

export default MyBusiness;
